import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { track } from 'meta-pixel';
interface CTAButtonProps {
  text?: string;
  onClick?: () => void;
  className?: string;
  fullWidth?: boolean;
  price?: string;
  originalPrice?: string;
  discountLabel?: string;
}
export function CTAButton({
  text = 'Get the Plan',
  onClick,
  className = '',
  fullWidth = false,
  price,
  originalPrice,
  discountLabel
}: CTAButtonProps) {
  const handleClick = () => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'The Nap-Trapped Reset',
        content_type: 'product',
        value: 6.39,
        currency: 'USD'
      });
    }
    if (onClick) {
      onClick();
    } else {
      window.open('https://www.gemmamama.com/cart/45389317111947:1', '_blank');
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`
        bg-sage hover:bg-sage-dark text-cream font-medium text-lg md:text-xl py-4 px-8 rounded-xl
        shadow-lg hover:shadow-xl transition-colors duration-300
        flex items-center justify-center gap-3
        relative
        ${fullWidth ? 'w-full' : 'w-full md:w-auto'}
        ${className}
      `} data-id="element-1">
      {discountLabel && <span className="absolute -top-3 -right-3 bg-terracotta text-cream text-xs font-bold px-2.5 py-1 rounded-full shadow-md" data-id="element-2">
          {discountLabel}
        </span>}
      <span data-id="element-3">{text}</span>
      {(price || originalPrice) && <span className="flex items-center gap-2" data-id="element-4">
          {originalPrice && <span className="line-through opacity-60 text-base" data-id="element-5">
              {originalPrice}
            </span>}
          {price && <span className="font-bold text-xl md:text-2xl" data-id="element-6">{price}</span>}
        </span>}
      <ArrowRight className="w-5 h-5 ml-1" data-id="element-7" />
    </motion.button>;
}